module.exports = __webpack_public_path__ + "f2aaab47d924697415b98c1933034111.png";